import React, {Component} from 'react';

import queryString from 'query-string';

import View from './View.js';
import List from './List.js';
import Create from './Create.js';
import Update from './Update.js';


class BranchInfo extends Component {

	constructor(props) {
		super(props);
		const query =  queryString.parse(this.props.location.search);
		const type = query.type || "list";

		this.state= {
			type : type,
			query : query
		};
	}

	render() {
		const {type, query} = this.state;
		const userType = localStorage.getItem("login_user_type") || 'admin';
		const branchId = userType === 'branch' ? localStorage.getItem("login_branch_id") || 0 : 0;
		
		let view = null;
		
		if(userType === 'admin'){ // 관리자 접속 시 
			if(query.type === 'view' && query.id) {
				view = <Update id={query.id} />; // Update.js
			} else if (query.type === 'create') {
				view = <Create />; // Create.js
			} else {
				view = <List />; 
			}
		} else {
			view = branchId ? <View id={branchId} /> : null;
		}

		return view;
	}
}


export default BranchInfo;